import * as _ from 'lodash';
import { IWatrRequest, IWatrReimbursement, IFileUploadRecord } from '@nkr/models/index';
import { ReimbursementType } from '@nkr/enums/index';

const REQUEST_FILE_TYPE_ADDITIONAL_WEEKS_COMPLICATIONS_REPORT = 9;

function typeMatchesComplicationsReport(f: { fileType?: number | string; fileTypeDescription?: string }) {
    const t = Number(f.fileType);
    if (!Number.isNaN(t) && t === REQUEST_FILE_TYPE_ADDITIONAL_WEEKS_COMPLICATIONS_REPORT) {
        return true;
    }
    const desc = (f.fileTypeDescription || '').toLowerCase();
    return desc.includes('complication');
}

export function getActiveComplicationsReportFile(request: IWatrRequest | undefined): IFileUploadRecord | undefined {
    const rows = request?.fileUploadRecords || [];
    const matches = rows.filter(f => typeMatchesComplicationsReport(f) && f.isActive !== false);
    return _.maxBy(matches, f => (f.uploadedDateTime ? new Date(f.uploadedDateTime).getTime() : 0));
}

export function donorHasComplicationsEvidence(
    request: IWatrRequest | undefined,
    reimbursements: IWatrReimbursement[] | undefined
): boolean {
    if (!request) {
        return false;
    }
    if (request.hasComplications === true) {
        return true;
    }
    if (request.hasActiveComplicationsReport === true) {
        return true;
    }
    const reimb = reimbursements || [];
    if (reimb.some(
        x => x?.reimbursementType === ReimbursementType.WagesForComplication
            || x?.reimbursementType === ReimbursementType.TravelAndLodgingForComplication
    )) {
        return true;
    }
    if (getActiveComplicationsReportFile(request)) {
        return true;
    }
    return false;
}